"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementService = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const field_join_1 = require("./field.join/field.join");
const field_join_ikecalc_wire_1 = require("./field.join/field.join.ikecalc.wire");
const field_join_poleforeman_powercircuit_1 = require("./field.join/field.join.poleforeman.powercircuit");
const field_join_poleforeman_wire_1 = require("./field.join/field.join.poleforeman.wire");
class MeasurementService {
    constructor() {
        this.__priority = 100;
    }
    isFormSupported(form) {
        if (form == null) {
            return false;
        }
        if (form.metadata == null || form.metadata.import == null) {
            return false;
        }
        const type = form.metadata.import.type;
        return type === 'ikecalc' || type === 'spidacalc' || type === 'poleforeman';
    }
    getFieldJoins(collection) {
        const fieldJoins = [];
        collection.forEachField(field => {
            if (!core_shared_1.CollectionModelFieldHeight.isHeightField(field)) {
                return;
            }
            if (field_join_ikecalc_wire_1.IkeCalcWireAttachmentHeightFieldJoin.accepts(field)) {
                const fieldJoin = new field_join_ikecalc_wire_1.IkeCalcWireAttachmentHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
            else if (field_join_poleforeman_wire_1.PoleForemanWirePhaseHeightFieldJoin.accepts(field)) {
                const fieldJoin = new field_join_poleforeman_wire_1.PoleForemanWirePhaseHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
            else if (field_join_poleforeman_powercircuit_1.PoleForemanPowerCircuitPhaseHeightFieldJoin.accepts(field)) {
                const fieldJoin = new field_join_poleforeman_powercircuit_1.PoleForemanPowerCircuitPhaseHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
        });
        const matches = [];
        for (let i = 0; i < fieldJoins.length; i++) {
            const joiningField = fieldJoins[i];
            for (let j = i + 1; j < fieldJoins.length; j++) {
                const candidateJoiningField = fieldJoins[j];
                if (joiningField.type === candidateJoiningField.type && joiningField.field.schema.id === candidateJoiningField.field.schema.id && joiningField.joins(candidateJoiningField)) {
                    const match = new field_join_1.FieldJoinMatch(joiningField, candidateJoiningField);
                    matches.push(match);
                    break;
                }
            }
        }
        return matches;
    }
}
exports.MeasurementService = MeasurementService;
//# sourceMappingURL=measurement.service.js.map